import { VALUE_VIEW_MODELS_LOAD_SUCCESS, VALUE_VIEW_MODELS_LOAD } from './valueViewModels.constants';
import { IValueViewModel } from '../../models';
import { StoreItem } from '../Store';
import { GROUP_ADD_SUCCESS, GROUP_DELETE_SUCCESS } from '../groups/groups.constants';
import { IDENTIFIER_SAVE_SUCCESS, IDENTIFIER_ADD_SUCCESS } from '../identifiers/identifiers.constants';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';
import { TAGS_UPDATE_SUCCESS } from '../tags/tags.constants';

export function valueViewModelsReducer(state: StoreItem<IValueViewModel> = new StoreItem<IValueViewModel>(), action: { type: string, payload: any }) {
    const dic = {};
    let newState = state;
    if (action && action.type) {
        switch (action.type) {
            case VALUE_VIEW_MODELS_LOAD:
                newState = new StoreItem<IValueViewModel>();
                newState.isLoading = true;
                newState.dictionary = state.dictionary;
                break;
            case VALUE_VIEW_MODELS_LOAD_SUCCESS:
                action.payload.forEach(element => dic[element.guid] = element);
                newState = {
                    dictionary: dic,
                    isLoading: false,
                    isLoaded: true,
                    hasError: false,
                    error: null
                };
                break;
            // case IDENTIFIER_DUPLICATE_SUCCESS:
            // case IDENTIFIERS_SAVE_SUCCESS:
            // case TAGS_DELETE_SUCCESS:
            // case TAG_CREATE_SUCCESS:
            case GROUP_ADD_SUCCESS:
            case GROUP_DELETE_SUCCESS:
            case IDENTIFIER_ADD_SUCCESS:
            case IDENTIFIER_SAVE_SUCCESS:
            case TAGS_UPDATE_SUCCESS:
            case APPLICATION_DISCONNECTED:
                newState = new StoreItem<IValueViewModel>();
                break;
        }
    }
    return newState;
}